var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<header class=\"lbModal_header\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2>Fare Conditions - {{ vm.carrierName }}</h2>\n</header>\n<div class=\"lbModal_body\" ng-switch=\"vm.rulesType\">\n<div ng-switch-when=\"ExternalUrl\" ng-bind-html=\"vm.fareRulesText\"></div>\n<pre ng-switch-default>{{ vm.fareRulesText }}</pre>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>";
var id1="components/lbFareRulesModal/lbFareRulesModal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbFareRulesModal/lbFareRulesModal.html
// module id = 1197
// module chunks = 1